(function() {
	'use strict';
	var $window = $(window);

	//This will open platform respective accordion panel (from href detection)
	$window.on('load', function() {
		var hash = location.hash.replace('#','');

		if (!['pc', 'mac', 'android', 'ios'].includes(hash)) {
			hash = "pc";
		}

		$('#panel-toggler-'+hash).toggleClass('collapsed');
		$('#panel-toggler-'+hash).attr('aria-expanded',true);
		$('#panel-content-'+hash).toggleClass('show');
	});
})();


var slider0 = tns({
	container: ".slider-items-pc-devices",
	controlsContainer: ".slider-controls-pc-devices",
	items: 1,
	slideBy: 2,
	loop: false,
	navPosition: "bottom",
	controls: true,
	mouseDrag: true,
	edgePadding: 16,
	gutter: 16,
	responsive: {
		"768": {
			fixedWidth: 310,
			items: 2,
			edgePadding: 60,
			gutter: 24
		},
		"1365": {
			fixedWidth: 320,
			items: 2,
			edgePadding: 80,
			gutter: 84
		}
	}
});
var slider1 = tns({
	container: ".slider-items-mac-devices",
	controlsContainer: ".slider-controls-mac-devices",
	items: 1,
	slideBy: 2,
	loop: false,
	navPosition: "bottom",
	controls: true,
	mouseDrag: true,
	edgePadding: 16,
	gutter: 16,
	responsive: {
		"768": {
			fixedWidth: 310,
			items: 2,
			edgePadding: 60,
			gutter: 24
		},
		"1365": {
			fixedWidth: 320,
			items: 2,
			edgePadding: 80,
			gutter: 84
		}
	}
});
var slider2 = tns({
	container: ".slider-items-android-devices",
	controlsContainer: ".slider-controls-android-devices",
	items: 1,
	slideBy: 2,
	loop: false,
	navPosition: "bottom",
	controls: true,
	mouseDrag: true,
	edgePadding: 16,
	gutter: 16,
	responsive: {
		"768": {
			fixedWidth: 310,
			items: 2,
			edgePadding: 60,
			gutter: 24
		},
		"1365": {
			fixedWidth: 320,
			items: 2,
			edgePadding: 80,
			gutter: 84
		}
	}
});
